<template>
  <div id="application-layout" class="application-layout">
    <site-header v-if="!isGuestLoginEnabled && !isNotAuthorizedPage"></site-header>

    <environment-alert />
    <main class="main-content d-flex flex-column align-items-center
        justify-content-start">
        <BaseLayout v-if="!isHomePage">
          <router-view></router-view>
        </BaseLayout>
        <router-view v-else></router-view>
    </main>
    <site-footer v-if="!isGuestLoginEnabled && !isNotAuthorizedPage"></site-footer>
  </div>
</template>

<script>
import EnvironmentAlert from '@/components/EnvironmentAlert.vue';
import SiteHeader from '../components/headers/SiteHeader.vue';
import SiteFooter from '../components/footers/SiteFooter.vue';
import BaseLayout from '../components/bases/BaseLayout.vue';

export default {
  name: 'ApplicationLayout',

  components: {
    SiteHeader,
    SiteFooter,
    EnvironmentAlert,
    BaseLayout,
  },

  data() {
    return {

    };
  },

  computed: {
    isGuestLoginEnabled() {
      return this.$store.state.partners.currentPartner.settings.enable_partner_guest_user === true;
    },

    isNotAuthorizedPage() {
      return this.$route.name === 'NotAuthorized';
    },

    isHomePage() {
      return this.$route.name === 'home';
    }
  },
};

</script>

<style>
  @import '../assets/stylesheets/layouts/application_layout.scss';
</style>
